const NotificationBar = ()=>{
    return (
        <div
              className="flex items-center justify-between p-4 mb-8 text-sm font-semibold text-white bg-blue-800 rounded-lg shadow-md focus:outline-none focus:shadow-outline-teal"
               
            >
              <div className="flex items-center">
               
                <span>..</span>
              </div>
              <span> LuckyBox</span>
            </div>
    );
}

export default NotificationBar;